<template>
  <div>
    <div class="ts-flex">
      <div class="ts-relative ts-w-full">
        <input
          v-model.trim="search"
          ref="search"
          type="text"
          class="ts-w-full ts-border ts-float-right ts-px-2 ts-py-1 ts-rounded ts-outline-none ts-pr-6"
          :placeholder="$t('quotation.searchProductList')"
        />
        <span
          class="ts-absolute ts-right-0 ts-mt-1 ts-mr-2"
          style="margin-top: 7px"
          ><i class="fa fa-search"></i
        ></span>
      </div>
    </div>
    <br />
    <div class="max-h ts-px-3">
      <table class="ts-w-full">
        <tr
          class="ts-border-b ts-border-gray-400"
          v-for="(product, index) in getProduct({
            chosenProduct: model.item_list,
            search: search
          })"
          :key="index"
        >
          <td class="ts-text-xs">{{ product.pro_group_name_en }}</td>
          <td class="ts-text-xs">{{ product.barcode }}</td>
          <td class="ts-text-xs">{{ product.product_name_en }}</td>
          <td class="ts-text-right">
            <input
              v-model="product.qty"
              type="number"
              placeholder="qty"
              class="ts-w-16 ts-outline-none ts-border-t ts-px-2 ts-rounded ts-mt-2 ts-text-xs"
              @keypress.enter="addItem(product)"
            />
          </td>
          <td style="width:1%" class="text-center ts-pl-4">
            <a
              href="#"
              v-tooltip="$t('add')"
              @click.prevent="addItem(product)"
              class="ts-mb-0"
            >
              <i class="fa fa-plus"></i>
            </a>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'productList',
  props: ['value'],
  data() {
    return {
      search: '',
      model: {}
    }
  },
  created() {
    this.model = this.value
    this.$nextTick(() => {
      this.$refs.search.focus()
    })
  },
  computed: {
    ...mapGetters('wholesale/quotation', [
      'getProduct',
      'getUom',
      'isDefaultUom',
      'getSalePrice'
    ])
  },
  methods: {
    addItem(product) {
      var uom_id = this.isDefaultUom(product.product_id)
      this.model.item_list.push({
        product_id: product.product_id,
        uom_id: uom_id,
        quantity: product.qty ? product.qty : 1,
        unit_price: this.getSalePrice({
          product_id: product.product_id,
          uom_id: uom_id
        }),
        remarks: '',
        amount: 0,
        discount_type: '%',
        discount_rate: 0,
        vat_rate: 0
      })
      this.$emit('calculate')
      this.$nextTick(() => {
        this.$refs.search.focus()
        this.$refs.search.select()
      })
    }
  }
}
</script>

<style scoped>
.max-h {
  height: 400px;
  max-height: 500px;
  overflow: scroll;
}
</style>
